import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const offensity = defineConnector({
  identifier: "offensity",
  name: "Offensity",
  tagLine: "External attack surface monitoring",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://reporting.offensity.com/api/v1"),
  auth: headerAuth([
    {
      name: "Authorization",
      value: { from: "template", template: "Token {secrets.apiToken}" },
    },
    { name: "Accept", value: { from: "literal", value: "application/json" } },
  ]),
  steps: [
    {
      title: "Set up Offensity",
      items: [
        {
          kind: "markdown",
          content:
            "In your Offensity reporting account, open **Account Settings → API Tokens** and create a token. Enter it below. See the [official API client](https://github.com/offensity/offensity-api-client).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "baseUrl",
          label: "API base URL",
          required: true,
          defaultValue: "https://reporting.offensity.com/api/v1/",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "Use the production reporting host documented by Offensity’s official API client. No separate regional host selection is documented.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: {
            kind: "secrets",
            field: "apiToken",
          },
          helperText:
            "Create an API token in your Offensity reporting account under Account Settings → API Tokens. The public client documents the token settings page; copy the token when it is generated.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://reporting.offensity.com/api/v1")
          .trim()
          .replace(/\/+$/, "") + "/scanprofiles/?is_enabled=true&page_size=1",
      ...{ method: "GET", headers: { Accept: "application/json" } },
    }),
  },
});
